import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action, on, createReducer } from '@ngrx/store';

import { auditLogAdapter } from '../shared-audit.adapters';
import {
  AircraftTypeRatingAudit,
  BusinessCategoryAudit,
  CompanyAddressAudit,
  CompanyProfileAudit,
  CompanyProfileSkeleton,
  CrewMemberTypeAudit,
  CustomerDutyAudit,
  DelayTypeAudit,
  DepartmentAudit,
  DutyTimeAllowanceAudit,
  DutyTimeBufferAudit,
  ExpenseTypeAudit,
  JobGradeAudit,
  PaymentTypeAudit,
  StaffEventTypeAudit,
  StaffGroupAudit
} from '../../+models/company-profile-audit.model';
import * as actions from './company-profile.actions';

// States

// company profile skeleton

interface CompanyProfileSkeletonState extends EntityState<CompanyProfileSkeleton> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
}

// company profile
interface CompanyProfileAuditState extends EntityState<CompanyProfileAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// aircraft type rating
interface AircraftTypeRatingAuditState extends EntityState<AircraftTypeRatingAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// company address
interface CompanyAddressAuditState extends EntityState<CompanyAddressAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// customer duty
interface CustomerDutyAuditState extends EntityState<CustomerDutyAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// delay type
interface DelayTypeAuditState extends EntityState<DelayTypeAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// department
interface DepartmentAuditState extends EntityState<DepartmentAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// duty time buffer
interface DutyTimeBufferAuditState extends EntityState<DutyTimeBufferAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// expense types
interface ExpenseTypeAuditState extends EntityState<ExpenseTypeAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// crew member type
interface CrewMemberTypeAuditState extends EntityState<CrewMemberTypeAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// payment type
interface PaymentTypeAuditState extends EntityState<PaymentTypeAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// business category
interface BusinessCategoryAuditState extends EntityState<BusinessCategoryAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// job grade
interface JobGradeAuditState extends EntityState<JobGradeAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// staff event type
interface StaffEventTypeAuditState extends EntityState<StaffEventTypeAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// staff group
interface StaffGroupAuditState extends EntityState<StaffGroupAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}
// duty time allowance
interface DutyTimeAllowanceAuditState extends EntityState<DutyTimeAllowanceAudit> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loaded: boolean;
  loading: boolean;
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

// interface AircraftTypeRatingTypeState extends EntityState<RefTypeItem> {
// eslint-disable-next-line
//   error: any;
//   loading: boolean;
//   loaded: boolean;
// }

//Adapters

// company profile skeleton
const companyProfileSkeletonAdapter = createEntityAdapter<CompanyProfileSkeleton>({
  selectId: p => p.customerId
});

// Entity selectors

// company profile skeleton
export const companyProfileSkeletonSelectors = companyProfileSkeletonAdapter.getSelectors();
// company profile
export const companyProfileAuditSelectors = auditLogAdapter.getSelectors();
// aircraft type rating
export const aircraftTypeRatingAuditSelectors = auditLogAdapter.getSelectors();
// company address
export const companyAddressAuditSelectors = auditLogAdapter.getSelectors();
// customer duty
export const customerDutyAuditSelectors = auditLogAdapter.getSelectors();
// delay type
export const delayTypeAuditSelectors = auditLogAdapter.getSelectors();
// department
export const departmentAuditSelectors = auditLogAdapter.getSelectors();
// duty time buffer
export const dutyTimeBufferAuditSelectors = auditLogAdapter.getSelectors();
// expense types
export const expenseTypeAuditSelectors = auditLogAdapter.getSelectors();
// crew member type
export const crewMemberTypeAuditSelectors = auditLogAdapter.getSelectors();
// payment type
export const paymentTypeAuditSelectors = auditLogAdapter.getSelectors();
// business category
export const businessCategoryAuditSelectors = auditLogAdapter.getSelectors();
// job grade
export const jobGradeAuditSelectors = auditLogAdapter.getSelectors();
// staff event type
export const staffEventTypeAuditSelectors = auditLogAdapter.getSelectors();
// staff group
export const staffGroupAuditSelectors = auditLogAdapter.getSelectors();
// duty time allowance
export const dutyTimeAllowanceAuditSelectors = auditLogAdapter.getSelectors();

// Initial States

// company profile skeleton
const companyProfileSkeletonInitialState = companyProfileSkeletonAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false
});
// company profile
const companyProfileAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// aircraft type rating
const aircraftTypeRatingAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// company address
const companyAddressAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// customer duty
const customerDutyAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// delay type
const delayTypeAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// department
const departmentAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// duty time buffer
const dutyTimeBufferAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// expense types
const expenseTypeAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// crew member type
const crewMemberTypeAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// payment type
const paymentTypeAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// business category
const businessCategoryAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// job grade
const jobGradeAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// staff event type
const staffEventTypeAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});
// staff group
const staffGroupAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});

// duty time allowance
const dutyTimeAllowanceAuditInitialState = auditLogAdapter.getInitialState({
  error: null,
  loaded: false,
  loading: false,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
});

export interface State {
  companyProfileSkeleton: CompanyProfileSkeletonState;
  companyProfileAudit: CompanyProfileAuditState;
  aircraftTypeRatingAudit: AircraftTypeRatingAuditState;
  companyAddressAudit: CompanyAddressAuditState;
  customerDutyAudit: CustomerDutyAuditState;
  delayTypeAudit: DelayTypeAuditState;
  departmentAudit: DepartmentAuditState;
  dutyTimeBufferAudit: DutyTimeBufferAuditState;
  expenseTypeAudit: ExpenseTypeAuditState;
  crewMemberTypeAudit: CrewMemberTypeAuditState;
  paymentTypeAudit: PaymentTypeAuditState;
  businessCategoryAudit: BusinessCategoryAuditState;
  jobGradeAudit: JobGradeAuditState;
  staffEventTypeAudit: StaffEventTypeAuditState;
  staffGroupAudit: StaffGroupAuditState;
  dutyTimeAllowanceAudit: DutyTimeAllowanceAuditState;
}

const initialState: State = {
  companyProfileSkeleton: companyProfileSkeletonInitialState,
  companyProfileAudit: companyProfileAuditInitialState,
  aircraftTypeRatingAudit: aircraftTypeRatingAuditInitialState,
  companyAddressAudit: companyAddressAuditInitialState,
  customerDutyAudit: customerDutyAuditInitialState,
  delayTypeAudit: delayTypeAuditInitialState,
  departmentAudit: departmentAuditInitialState,
  dutyTimeBufferAudit: dutyTimeBufferAuditInitialState,
  expenseTypeAudit: expenseTypeAuditInitialState,
  crewMemberTypeAudit: crewMemberTypeAuditInitialState,
  paymentTypeAudit: paymentTypeAuditInitialState,
  businessCategoryAudit: businessCategoryAuditInitialState,
  jobGradeAudit: jobGradeAuditInitialState,
  staffEventTypeAudit: staffEventTypeAuditInitialState,
  staffGroupAudit: staffGroupAuditInitialState,
  dutyTimeAllowanceAudit: dutyTimeAllowanceAuditInitialState
};

const companyProfileReducer = createReducer<State>(
  initialState,
  on(actions.ResetCompanyProfile, () => initialState),

  on(actions.LoadCompanyProfileAuditSkeleton, state => ({
    ...state,
    companyProfileSkeleton: { ...state.companyProfileSkeleton, loading: true }
  })),

  on(actions.CompanyProfileAuditSkeletonLoaded, (state, action) => ({
    ...state,
    companyProfileSkeleton: {
      ...state.companyProfileSkeleton,
      ...companyProfileSkeletonAdapter.addOne(action.payload, state.companyProfileSkeleton),
      loaded: true,
      loading: false
    }
  })),

  on(actions.LoadCompanyProfileAudit, (state, action) => ({
    ...state,
    companyProfileAudit: {
      ...state.companyProfileAudit,
      lastAuditLogId:
        state.companyProfileAudit.selectedId === action.companyProfileId
          ? state.companyProfileAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.CompanyProfileAuditLoaded, (state, action) => ({
    ...state,
    companyProfileAudit: {
      ...state.companyProfileAudit,
      ...(!state.companyProfileAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.companyProfileAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.companyProfileAudit)),
      loaded: true,
      loading: false,
      selectedId: action.companyProfileId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadAircraftTypeRatingAudit, (state, action) => ({
    ...state,
    aircraftTypeRatingAudit: {
      ...state.aircraftTypeRatingAudit,
      lastAuditLogId:
        state.aircraftTypeRatingAudit.selectedId === action.aircraftTypeRatingId
          ? state.aircraftTypeRatingAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.AircraftTypeRatingAuditLoaded, (state, action) => ({
    ...state,
    aircraftTypeRatingAudit: {
      ...state.aircraftTypeRatingAudit,
      ...(!state.aircraftTypeRatingAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.aircraftTypeRatingAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.aircraftTypeRatingAudit)),
      loaded: true,
      loading: false,
      selectedId: action.aircraftTypeRatingId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  // company address
  on(actions.LoadCompanyAddressAudit, (state, action) => ({
    ...state,
    companyAddressAudit: {
      ...state.companyAddressAudit,
      lastAuditLogId:
        state.companyAddressAudit.selectedId === action.companyAddressId
          ? state.companyAddressAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.CompanyAddressAuditLoaded, (state, action) => ({
    ...state,
    companyAddressAudit: {
      ...state.companyAddressAudit,
      ...(!state.companyAddressAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.companyAddressAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.companyAddressAudit)),
      loaded: true,
      loading: false,
      selectedId: action.companyAddressId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadCustomerDutyAudit, (state, action) => ({
    ...state,
    customerDutyAudit: {
      ...state.customerDutyAudit,
      lastAuditLogId:
        state.customerDutyAudit.selectedId === action.customerDutyId
          ? state.customerDutyAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.CustomerDutyAuditLoaded, (state, action) => ({
    ...state,
    customerDutyAudit: {
      ...state.customerDutyAudit,
      ...(!state.customerDutyAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.customerDutyAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.customerDutyAudit)),
      loaded: true,
      loading: false,
      selectedId: action.customerDutyId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadDelayTypeAudit, (state, action) => ({
    ...state,
    delayTypeAudit: {
      ...state.delayTypeAudit,
      lastAuditLogId:
        state.delayTypeAudit.selectedId === action.delayTypeId
          ? state.delayTypeAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.DelayTypeAuditLoaded, (state, action) => ({
    ...state,
    delayTypeAudit: {
      ...state.delayTypeAudit,
      ...(!state.delayTypeAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.delayTypeAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.delayTypeAudit)),
      loaded: true,
      loading: false,
      selectedId: action.delayTypeId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadDepartmentAudit, (state, action) => ({
    ...state,
    departmentAudit: {
      ...state.departmentAudit,
      lastAuditLogId:
        state.departmentAudit.selectedId === action.departmentId
          ? state.departmentAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.DepartmentAuditLoaded, (state, action) => ({
    ...state,
    departmentAudit: {
      ...state.departmentAudit,
      ...(!state.departmentAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.departmentAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.departmentAudit)),
      loaded: true,
      loading: false,
      selectedId: action.departmentId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadDutyTimeBufferAudit, (state, action) => ({
    ...state,
    dutyTimeBufferAudit: {
      ...state.dutyTimeBufferAudit,
      lastAuditLogId:
        state.dutyTimeBufferAudit.selectedId === action.dutyTimeBufferId
          ? state.dutyTimeBufferAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.DutyTimeBufferAuditLoaded, (state, action) => ({
    ...state,
    dutyTimeBufferAudit: {
      ...state.dutyTimeBufferAudit,
      ...(!state.dutyTimeBufferAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.dutyTimeBufferAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.dutyTimeBufferAudit)),
      loaded: true,
      loading: false,
      selectedId: action.dutyTimeBufferId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadExpenseTypeAudit, (state, action) => ({
    ...state,
    expenseTypeAudit: {
      ...state.expenseTypeAudit,
      lastAuditLogId:
        state.expenseTypeAudit.selectedId === action.expenseTypeId
          ? state.expenseTypeAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.ExpenseTypeAuditLoaded, (state, action) => ({
    ...state,
    expenseTypeAudit: {
      ...state.expenseTypeAudit,
      ...(!state.expenseTypeAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.expenseTypeAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.expenseTypeAudit)),
      loaded: true,
      loading: false,
      selectedId: action.expenseTypeId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadCrewMemberTypeAudit, (state, action) => ({
    ...state,
    crewMemberTypeAudit: {
      ...state.crewMemberTypeAudit,
      lastAuditLogId:
        state.crewMemberTypeAudit.selectedId === action.crewMemberTypeId
          ? state.crewMemberTypeAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.CrewMemberTypeAuditLoaded, (state, action) => ({
    ...state,
    crewMemberTypeAudit: {
      ...state.crewMemberTypeAudit,
      ...(!state.crewMemberTypeAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.crewMemberTypeAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.crewMemberTypeAudit)),
      loaded: true,
      loading: false,
      selectedId: action.crewMemberTypeId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPaymentTypeAudit, (state, action) => ({
    ...state,
    paymentTypeAudit: {
      ...state.paymentTypeAudit,
      lastAuditLogId:
        state.paymentTypeAudit.selectedId === action.paymentTypeId
          ? state.paymentTypeAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.PaymentTypeAuditLoaded, (state, action) => ({
    ...state,
    paymentTypeAudit: {
      ...state.paymentTypeAudit,
      ...(!state.paymentTypeAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.paymentTypeAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.paymentTypeAudit)),
      loaded: true,
      loading: false,
      selectedId: action.paymentTypeId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadBusinessCategoryAudit, (state, action) => ({
    ...state,
    businessCategoryAudit: {
      ...state.businessCategoryAudit,
      lastAuditLogId:
        state.businessCategoryAudit.selectedId === action.businessCategoryId
          ? state.businessCategoryAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.BusinessCategoryAuditLoaded, (state, action) => ({
    ...state,
    businessCategoryAudit: {
      ...state.businessCategoryAudit,
      ...(!state.businessCategoryAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.businessCategoryAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.businessCategoryAudit)),
      loaded: true,
      loading: false,
      selectedId: action.businessCategoryId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadJobGradeAudit, (state, action) => ({
    ...state,
    jobGradeAudit: {
      ...state.jobGradeAudit,
      lastAuditLogId:
        state.jobGradeAudit.selectedId === action.jobGradeId
          ? state.jobGradeAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.JobGradeAuditLoaded, (state, action) => ({
    ...state,
    jobGradeAudit: {
      ...state.jobGradeAudit,
      ...(!state.jobGradeAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.jobGradeAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.jobGradeAudit)),
      loaded: true,
      loading: false,
      selectedId: action.jobGradeId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadStaffEventTypeAudit, (state, action) => ({
    ...state,
    staffEventTypeAudit: {
      ...state.staffEventTypeAudit,
      lastAuditLogId:
        state.staffEventTypeAudit.selectedId === action.staffEventTypeId
          ? state.staffEventTypeAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.StaffEventTypeAuditLoaded, (state, action) => ({
    ...state,
    staffEventTypeAudit: {
      ...state.staffEventTypeAudit,
      ...(!state.staffEventTypeAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.staffEventTypeAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.staffEventTypeAudit)),
      loaded: true,
      loading: false,
      selectedId: action.staffEventTypeId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadStaffGroupAudit, (state, action) => ({
    ...state,
    staffGroupAudit: {
      ...state.staffGroupAudit,
      lastAuditLogId:
        state.staffGroupAudit.selectedId === action.staffGroupId
          ? state.staffGroupAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.StaffGroupAuditLoaded, (state, action) => ({
    ...state,
    staffGroupAudit: {
      ...state.staffGroupAudit,
      ...(!state.staffGroupAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.staffGroupAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.staffGroupAudit)),
      loaded: true,
      loading: false,
      selectedId: action.staffGroupId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadDutyTimeAllowanceAudit, (state, action) => ({
    ...state,
    dutyTimeAllowanceAudit: {
      ...state.dutyTimeAllowanceAudit,
      lastAuditLogId:
        state.dutyTimeAllowanceAudit.selectedId === action.dutyTimeAllowanceId
          ? state.dutyTimeAllowanceAudit.lastAuditLogId
          : null,
      loading: true
    }
  })),

  on(actions.DutyTimeAllowanceAuditLoaded, (state, action) => ({
    ...state,
    dutyTimeAllowanceAudit: {
      ...state.dutyTimeAllowanceAudit,
      ...(!state.dutyTimeAllowanceAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.dutyTimeAllowanceAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.dutyTimeAllowanceAudit)),
      loaded: true,
      loading: false,
      selectedId: action.dutyTimeAllowanceId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return companyProfileReducer(state, action);
}
